import axios from 'axios';
class RestHttpAdapter {
    api;
    sessionService;
    constructor({ sessionService }) {
        this.sessionService = sessionService;
        this.api = axios.create({
            baseURL: '',
            timeout: 60_000,
        });
    }
    async setAuthorization() {
        this.api.defaults.headers.common.Authorization = await this.sessionService.getBearer();
    }
    async setXCurrentTiers() {
        this.api.defaults.headers.common['X-Current-Tiers'] = await this.sessionService.getTiersReference();
    }
    async beforeEach() {
        await this.setAuthorization();
        await this.setXCurrentTiers();
    }
    async get(url, config, disableBeforeEach) {
        if (!disableBeforeEach)
            await this.beforeEach();
        return this.api.get(url, config);
    }
    async delete(url, config) {
        await this.beforeEach();
        return this.api.delete(url, config);
    }
    async put(url, data, config) {
        await this.beforeEach();
        return this.api.put(url, data, config);
    }
    async post(url, data, config) {
        await this.beforeEach();
        return this.api.post(url, data, config);
    }
    async patch(url, data, config) {
        await this.beforeEach();
        return this.api.patch(url, data, config);
    }
}
export { RestHttpAdapter };
//# sourceMappingURL=rest-http.adapter.js.map